import { gsap } from 'gsap'

export default class Smooth {
  linkTarget: string
  linkElm: HTMLElement[]
  breakPoint: number
  pcWaitTime: number
  spWaitTime: number
  exceptionId: string[]
  exceptionFn: ((id: string) => void) | null

  constructor(config: {
    linkTarget?: string
    breakPoint?: number
    pcWaitTime?: number
    spWaitTime?: number
    exceptionId?: string[]
    exceptionFn?: (id: string) => void
  }) {
    this.linkTarget = config.linkTarget || '.nav_link a[href*="#"]'
    this.linkElm = gsap.utils.toArray<HTMLElement>(this.linkTarget)
    this.breakPoint = config.breakPoint || 768
    this.pcWaitTime = config.pcWaitTime || 0
    this.spWaitTime = config.spWaitTime || 0
    this.exceptionId = config.exceptionId || []
    this.exceptionFn = config.exceptionFn || null

    // 初期処理
    window.addEventListener('DOMContentLoaded', () => this.setLinkClick())
  }

  setLinkClick() {
    this.linkElm.forEach((elm, i) => {
      elm.addEventListener('click', (e) => this.linkClickAction(e))
    })
  }

  linkClickAction(e: MouseEvent) {
    // console.log('e', e.target)
    if (!this.internalLink(e)) return
    e.preventDefault()

    // 遷移先の要素
    const tag = this.tagName(e.target)

    if (this.checkId(tag)) return

    const linkSection = document.querySelector(tag)
    const clientRect = linkSection.getBoundingClientRect()
    const scrollPosition = window.scrollY + clientRect.top

    // console.log('linkClickAction', tag, linkSection)

    const time = this.waitTime()
    if (time) {
      setTimeout(() => {
        this.onScroll(scrollPosition)
      }, time)
    } else {
      this.onScroll(scrollPosition)
    }
  }

  internalLink(e: MouseEvent) {
    const uri = new URL(window.location.href)
    const target = this.getLinkTag(e.target)
    const href = uri.href
    const targetHref = target.href
    const page = href.includes('#')
      ? href.substring(0, href.indexOf('#'))
      : href
    const link = targetHref.includes('#')
      ? targetHref.substring(0, targetHref.indexOf('#'))
      : targetHref
    // if (page.includes('#')) page = page.substring(0, page.indexOf('#'))
    // if (link.includes('#')) link = link.substring(0, link.indexOf('#'))
    const val = page === link ? true : false
    return val
  }

  tagName(target: any) {
    // タグ名を返す
    if (target.tagName === 'A') return target.hash
    let value = target.closest('a')
    return value.hash
  }

  checkId(tag: any) {
    const id = tag.replace('#', '')
    const val = this.exceptionId.includes(id as never)
    if (this.exceptionFn && val) this.exceptionFn(id)
    return val
  }

  waitTime() {
    // 待ち時間を設定
    if (this.breakPoint <= window.innerWidth) {
      return this.pcWaitTime
    } else {
      return this.spWaitTime
    }
  }

  getLinkTag(elm: any) {
    // クリックされた要素のAタグを返す
    if (elm.tagName === 'A') {
      return elm
    } else {
      return elm.closest('a')
    }
  }

  onScroll(val: any) {
    // スクロールアニメーションを実行
    window.scrollTo({
      top: val,
      behavior: 'smooth',
    })
  }
}
